import { render, staticRenderFns } from "./ProductUpdater.vue?vue&type=template&id=1bb233c9&"
import script from "./ProductUpdater.vue?vue&type=script&lang=js&"
export * from "./ProductUpdater.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports